exports = module.exports = {
	baseUrl : "https://test.aperam.bfast.link"
	// baseUrl : "http://aperam.bfast.link"
};



//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 23
// module chunks = 0